import { useDispatch } from 'react-redux';
import { Button, ResponsiveDialog } from 'ui';
import { setShowTaskCountModal } from '../../../store/siteInfoSlice';

export default function GodaddyConfirmLessTaskModal({ handleGodaddyDone }: { handleGodaddyDone: () => void }) {
    const dispatch = useDispatch();

    return (
        <ResponsiveDialog.Content
            className="text-textcolor isolate max-w-[512px] m-auto my-0 border-none  "
            onInteractOutside={(event: { preventDefault: () => unknown; }) => event.preventDefault()}
            container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
        >
            <div className="w-full flex flex-col items-center justify-center mt-6 rounded-[18px] bg-background">
                <span className=' text-center w-full font-medium mb-[20px] '>
                    You are about to submit your revisions to your website builder, and
                    we are excited to get to work!
                </span>
                <div className="text-left font-normal text-sm ">
                    <div>
                        Before you hit
                        <span className='font-bold'>
                            {' '}
                            submit
                        </span>
                        ,
                        <span className='mb-[-20px] font-normal'>
                            {' '}
                            please take a moment to review all pages of your new site to
                            ensure we have all the information needed to deliver you the
                            best version possible.
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex justify-between gap-2 py-4">
                <Button
                    variant="outline"
                    size="sm"
                    className="w-1/2"
                    onClick={() => dispatch(setShowTaskCountModal(false))}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleGodaddyDone}
                    size="sm"
                    className="w-1/2"
                >
                    Submit
                </Button>
            </div>
        </ResponsiveDialog.Content >
    );
}
